import { ModalContext } from 'app/app';
import axios from 'axios';
import { IconedButton } from 'components/IconedButton';
import { Pagination } from 'components/Pagination';
import {
  Animate,
  Grid,
  Icon,
  Search,
  Table,
  ViewContext,
} from 'components/lib';
import DateUtils from 'helpers/dateUtils';
import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styles from './styles.module.scss';

export function DriversArchived(props) {
  const { id: company_id } = useParams();
  const [payload, setPayload] = useState();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [searchQueryString, setSearchQueryString] = useState('');

  const { setModal } = useContext(ModalContext);
  const context = useContext(ViewContext);

  const format = new DateUtils();

  async function runAPI(page, search) {
    setLoading(true);

    await axios
      .get(
        `/api/driver?page=${page}&search=${search}&company_id=${company_id}&active=false`
      )
      .then((res) => {
        setLoading(false);
        setPayload(res.data.data);

        var tempData = [];

        res.data.data.data.map((value, index) => {
          tempData.push({
            id: value.id,
            name: value.name,
            'DL Number': value.license_number,
            State: value.license_state,
            'Date of Birth': value.date_of_birth
              ? format.isoDate(value.date_of_birth)
              : '',
            'Years of Experience': value.years_of_experience,
            front_license_link: value.back_license,
            'Front DL': value.front_license ? (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-start',
                  cursor: 'pointer',
                }}
                onClick={() => window.open(value.front_license)}
              >
                <Icon image={'image'} />
              </div>
            ) : (
              ''
            ),
            back_license_link: value.back_license,
            'Back DL': value.back_license ? (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-start',
                  cursor: 'pointer',
                }}
                onClick={() => window.open(value.back_license)}
              >
                <Icon image={'image'} />
              </div>
            ) : (
              ''
            ),
            status: value.status,
          });
        });

        setData(tempData);
      })
      .catch((err) => {
        setLoading(false);

        console.log(err);

        context.notification.show(
          'Failed to load table data',
          'error',
          true,
          'toast',
          'x-circle'
        );
      });
  }

  async function activeDriver(id) {
    await axios
      .patch(`/api/driver/${id}`, { active: true, status: 'active' })
      .then((res) => {
        setLoading(false);

        runAPI(page, searchQueryString);

        context.notification.show(
          'Driver actived!',
          'success',
          true,
          'toast',
          'check-circle'
        );
      })
      .catch((err) => {
        setLoading(false);

        context.notification.show(
          'Failed to active driver.',
          'error',
          true,
          'toast',
          'x-circle'
        );
      });
  }

  useEffect(() => {
    runAPI(page, searchQueryString);
  }, [searchQueryString]);

  useEffect(() => {
    runAPI(page, '');
  }, []);

  return (
    <Animate type="pop">
      <div
        style={{
          display: 'flex',
          alignContent: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div style={{ display: 'flex' }}>
          <div
            onClick={() => {
              window.location.href =
                '/app/company/' + company_id + '/drivers';
            }}
            style={{
              backgroundColor: '#EAEAEA',
              width: '150px',
              color: '#090E3480',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 10,
              fontSize: 16,
              fontWeight: 600,
              borderTopLeftRadius: 10,
              borderTopRightRadius: 10,
              cursor: 'pointer',
            }}
          >
            Active
          </div>
          <div
            style={{
              width: '150px',
              backgroundColor: 'black',
              color: '#fff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 10,
              fontSize: 16,
              fontWeight: 600,
              borderTopLeftRadius: 10,
              borderTopRightRadius: 10,
              cursor: 'default',
            }}
          >
            Archived
          </div>
        </div>
        <div
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          <IconedButton
            size="140px"
            color="#d32425"
            textColor="white"
            icon="plus-circle"
            text="Add Driver"
            marginRight
            action={() =>
              setModal({
                name: 'driver_modal',
                action: () => runAPI(page, searchQueryString),
              })
            }
          />
        </div>
      </div>
      <Grid cols="1">
        <div className={styles.wrapper}>
          <div style={{ margin: 20 }}>
            <div style={{ marginBottom: 30 }}>
              <Search
                callback={(query) => {
                  setSearchQueryString(query);
                }}
              />
            </div>
            <Table
              loading={loading}
              data={payload && payload.data ? data : null}
              badge={{
                col: 'status',
                condition: [
                  { value: 'Active', color: 'green' },
                  { value: 'Inactive', color: 'red' },
                ],
              }}
              hide={[
                'link',
                'id',
                'front_license_link',
                'back_license_link',
              ]}
              actions={{
                custom: [
                  {
                    icon: 'archive',
                    tooltip: 'Active this driver',
                    color: '#d32425',
                    action: (row) => {
                      activeDriver(row.id);
                    },
                  },
                ],
              }}
            />
            {payload && (
              <Pagination
                pagesCount={payload.pages_count}
                active={payload.page}
                onChange={async (newPage) => {
                  setPage(newPage);
                  runAPI(newPage, searchQueryString);
                }}
              />
            )}
          </div>
        </div>
      </Grid>
    </Animate>
  );
}
